import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { createFileRoute } from "@tanstack/react-router";

import {
  AdminMediaDayStatusBoard,
  PublicMediaDayStatusBoard,
  validateMediaDayStatusSearch,
} from "@/features/media-day-status/board";
import { convexAuthClient } from "@/lib/auth-client";
import { authConvexClient } from "@/lib/convex-clients";
import { useRoleAccess } from "@/lib/role-access";

export const Route = createFileRoute("/media-day/status/$token")({
  head: () => ({ meta: [{ title: "Media Day Status" }] }),
  validateSearch: validateMediaDayStatusSearch,
  component: PublicMediaDayStatusRoute,
});

function PublicMediaDayStatusRoute() {
  const { token } = Route.useParams();
  const search = Route.useSearch();
  const { isAdmin } = useRoleAccess();

  return isAdmin ? (
    <ConvexBetterAuthProvider client={authConvexClient} authClient={convexAuthClient}>
      <AdminMediaDayStatusBoard token={token} search={search} />
    </ConvexBetterAuthProvider>
  ) : (
    <PublicMediaDayStatusBoard token={token} search={search} />
  );
}
